import { useEffect, useState } from 'react';
import { CATEGORIES, leftOut } from './AdminBulkEmail';
import { api, day, errorText, number } from './adminFormat';

const STATE = { sending: 'Sending', done: 'Done', interrupted: 'Stopped' };

function Campaign({ item, onResumed }) {
  const [details, setDetails] = useState(null);
  const [state, setState] = useState({});
  const open = async () => {
    if (details) { setDetails(null); return; }
    try { setDetails(await api.get(`/campaigns/${item.id}`)); } catch (err) { setState({ message: errorText(err), error: true }); }
  };
  const resume = async () => {
    setState({ busy: true });
    try { await api.post(`/campaigns/${item.id}/resume`); setState({}); onResumed(); } catch (err) { setState({ message: errorText(err), error: true }); }
  };
  const lines = leftOut(item.skipped);
  return <li>
    <div className="adm-campaign-head">
      <strong>{item.subject}</strong>
      <span className="adm-badge adm-badge-soft">{CATEGORIES[item.category]?.label || item.category}</span>
      <span className={`adm-badge${item.state === 'interrupted' ? ' adm-badge-warn' : ''}`}>{STATE[item.state] || item.state}</span>
    </div>
    <p>{number(item.sent)} sent{item.failed ? `, ${number(item.failed)} not delivered` : ''}{item.queued ? `, ${number(item.queued)} waiting` : ''} · {number(item.total)} recipients
      {lines.length > 0 && <> · left out: {lines.join(', ')}</>}</p>
    <small>{item.created_by} · {day(item.created_at)}</small>
    <div className="adm-form-row">
      <button type="button" className="adm-link" onClick={open}>{details ? 'Hide' : 'Show the email'}</button>
      {item.state === 'interrupted' && <button type="button" className="ws-secondary" onClick={resume} disabled={state.busy}>Resume sending</button>}
      {state.message && <span className="adm-feedback adm-error" role="alert">{state.message}</span>}
    </div>
    {details && <div className="adm-campaign-details">
      <p className="adm-sent-email">{details.body}</p>
      {details.failures.length > 0 && <><h4>Not delivered</h4><ul>{details.failures.map((f) => <li key={f.recipient}>{f.recipient}: {f.error}</li>)}</ul></>}
    </div>}
  </li>;
}

export default function AdminCampaigns() {
  const [list, setList] = useState(null);
  const [error, setError] = useState('');
  const [tick, setTick] = useState(0);
  useEffect(() => {
    let active = true;
    api.get('/campaigns').then((data) => { if (active) setList(data.campaigns); }).catch((err) => { if (active) setError(errorText(err)); });
    return () => { active = false; };
  }, [tick]);
  const sending = list?.some((c) => c.state === 'sending');
  useEffect(() => {   // follow emails being sent
    if (!sending) return undefined;
    const timer = setTimeout(() => setTick((n) => n + 1), 4000);
    return () => clearTimeout(timer);
  }, [sending, tick]);
  if (error) return <p className="adm-feedback adm-error" role="alert">{error}</p>;
  if (!list) return <p className="adm-muted" role="status">Loading…</p>;
  if (!list.length) return <p className="adm-muted">No group email yet. In the Users tab, tick the people (or select everyone matching your filters) and choose “Email them”.</p>;
  return <ul className="adm-campaigns">{list.map((item) => <Campaign key={item.id} item={item} onResumed={() => setTick((n) => n + 1)} />)}</ul>;
}
